import React     from 'react'; 
import landscape from './bsb_700.module.css';
import portrait      from './portrait.module.css';
import pic_coming_soon from '../pictures/We are working on it.webp';
import { Helmet }           from 'react-helmet';
  
  

export class BSB700 extends React.Component
{
    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  
    

    componentDidMount()
    {
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    };
   
     //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //------------------------------------------------------------------
    //  Prepare the render output
    //------------------------------------------------------------------
    render()
    { 
      this.component = 
      <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>
            <Helmet>
            <title>BSB 700</title>
            <meta name="description" content="BSB 700 hardware is under development and a first HW prototype is ready." />
            <meta charset="utf-8" />
            </Helmet>


            <img src={pic_coming_soon} alt="picture coming soon" />
          
      </div>
    
      return this.component ;
    }
}  

